import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';

import { Observable, BehaviorSubject } from 'rxjs';

import { NotificationService } from './notifications.service';



@Injectable({
	providedIn: 'root'
})
export class MessagingService {

	currentMessageSource = new BehaviorSubject(null);
	currentMessage = this.currentMessageSource.asObservable();
	userMsgToken = new BehaviorSubject<string>(null);
	registeredStatus = new BehaviorSubject<boolean>(false);

	get receiveMessage(): Observable<{}> {
		return this.angularFireMessaging.messages;
	}

	constructor(
		private notifications: NotificationService,
		private angularFireMessaging: AngularFireMessaging
	) { }

	updateToken(token) {
		this.notifications.registerDevice(token).subscribe();
		this.registeredStatus.next(true);
	}

	getPermission() {
		this.angularFireMessaging.requestToken.subscribe(
			(token) => {
				this.userMsgToken.next(token);
				this.updateToken(token);
			},
			(err) => {
				console.error('Unable to get permission to notify.', err);
			}
		);
	}

	deleteToken() {
		this.angularFireMessaging.deleteToken(this.userMsgToken.value);
		if (this.registeredStatus.value) {
			this.notifications.unregisterDevice().subscribe();
			this.registeredStatus.next(false);
		}
	}

}
